import { render, staticRenderFns } from "./Accruals.vue?vue&type=template&id=69667c1e&scoped=true"
import script from "./Accruals.vue?vue&type=script&lang=js"
export * from "./Accruals.vue?vue&type=script&lang=js"
import style0 from "./Accruals.vue?vue&type=style&index=0&id=69667c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69667c1e",
  null
  
)

export default component.exports